import React from "react";

import "./style.less";

import { type WithDynamicOptionsHOCProps, withDynamicOptionsAdapterHOC } from "@client/hocs/withDynamicOptions";
import SelectCommon, {
  DynamicSelect as DynamicSelectCommon,
  type DynamicSelectProps as DynamicSelectPropsCommon,
  SelectDropdown as SelectDropdownCommon,
  type SelectProps as SelectPropsCommon
} from "@common/controls/Inputs/Select/component";
import { type WithSearchHOCBaseProps } from "@common/controls/Inputs/Select/hocs/withSearch";
import { type OptionItem } from "@common/declarations";
import { ContentAlign } from "@common/hocs/withDropdown/lib";

export type SelectProps = Omit<SelectPropsCommon, "allOptions"> &
  WithSearchHOCBaseProps & {
    alwaysShowHeading?: boolean;
    searchNoExactMatchHint?: string;
  };
export const Select = (props: SelectProps) => <SelectCommon {...props} />;

export default Select;

export type DynamicSelectProps = Omit<SelectProps, "options"> & WithDynamicOptionsHOCProps<SelectProps>;
export const DynamicSelect = withDynamicOptionsAdapterHOC<Omit<SelectProps, "options">, OptionItem<any>>(
  (props: DynamicSelectPropsCommon) => <DynamicSelectCommon {...props} />
);

export type SelectDropdownProps = SelectPropsCommon & {
  align: ContentAlign;
};
export const SelectDropdown = (props: SelectDropdownProps) => <SelectDropdownCommon {...props} />;

export {
  SelectLazy,
  SelectWithAdd,
  type OptionItem,
  type SelectContentProps,
  type SelectPropsBase,
  type WithOptions
} from "@common/controls/Inputs/Select/component";
